export default function HeadingBlockEditor({ block, onChange }) {
    return (
        <div className="space-y-2">
            <input value={block.config.text} onChange={(e) => onChange({ config: {...block.config, text: e.target.value} })} className="w-full p-3 border rounded-lg bg-gray-50" placeholder="عنوان" />
            <select value={block.config.level} onChange={(e) => onChange({ config: {...block.config, level: Number(e.target.value)} })} className="w-full p-3 border rounded-lg bg-gray-50">
                {[1, 2, 3].map(l => <option key={l} value={l}>H{l}</option>)}
            </select>
        </div>
    );
}
